import type { SiteSummary } from '../site/site.interface';
import { SITE_TYPE } from '../site/site.interface';
import { ObjectFactory } from './object.factory';

export class SiteSummaryFactory extends ObjectFactory<SiteSummary> {
  protected getDefaults(): SiteSummary {
    return {
      code: 'S1',
      color: '#000',
      id: 'site-1',
      name: 'Main Warehouse',
      type: SITE_TYPE.WAREHOUSE,
    };
  }
}

export const siteSummaryFactory = new SiteSummaryFactory();
